<template>
  <section class="ProgramExperience">
    <TextEpsilon
      tag="h2"
      class="ProgramExperience__heading"
      v-html="`<span>Experience</span> ${name}`"
    />
    <CourtProgram
      side="bottom"
      class="ProgramExperience__court"
    />
    <div class="ProgramExperience__main">
      <ProgramElements
        :name="name"
        :elements="elements"
        class="ProgramExperience__elements"
      />
      <ProgramDescription
        :mailto="mailto"
        :description="description"
        class="ProgramExperience__description"
      />
    </div>
    <CourtProgram
      side="top"
      class="ProgramExperience__court"
    />
  </section>
</template>

<script>
  import TextEpsilon from './TextEpsilon';
  import CourtProgram from './CourtProgram';
  import ProgramElements from './ProgramElements';
  import ProgramDescription from './ProgramDescription';

  export default {
    components: {
      TextEpsilon,
      CourtProgram,
      ProgramElements,
      ProgramDescription,
    },
    props: {
      name: {
        type: String,
        required: true,
      },
      elements: {
        type: Array,
        required: true,
      },
      description: {
        type: String,
        required: true,
      },
      mailto: {
        type: String,
        default: null,
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .ProgramExperience {
    margin-right: spacing(base-beta) * -1;
    margin-left: spacing(base-beta) * -1;

    @include breakpoint(phablet) {
      margin-right: 0;
      margin-left: 0;
    }
  }

  .ProgramExperience__court {
    padding-right: spacing(base-gamma) * 2;
    padding-left: spacing(base-gamma) * 2;

    .ProgramExperience__heading + & {
      margin-top: spacing(program-tertiary);
    }
  }

  .ProgramExperience__heading {
    color: color(bronze);
    text-align: center;
  }

  .ProgramExperience__main {
    $padding: spacing(base-epsilon);

    padding-top: $padding;
    padding-bottom: $padding;

    @include breakpoint(phablet) {
      display: flex;
      align-items: flex-start;
      padding-right: spacing(base-gamma);
      padding-left: spacing(base-gamma);
    }
  }

  .ProgramExperience__elements {
    @include breakpoint(phablet) {
      width: calc(100% * (5 / 12));
      padding-right: spacing(base-gamma);
      padding-left: spacing(base-gamma);
    }
  }

  .ProgramExperience__description {
    margin-top: spacing(base-gamma) * 2;
    padding-right: spacing(base-gamma) * 2;
    padding-left: spacing(base-gamma) * 2;

    @include breakpoint(phablet) {
      margin-top: 0;
      padding-right: spacing(base-gamma);
      padding-left: spacing(base-gamma);
      width: calc(100% * (7 / 12));
    }
    // @include column;

    // width: percentage(7 / 12);
  }
</style>
